// Import Swiper JS
import Swiper from 'swiper'

function blogCategoryFilters() {
  const blogFilterSwipers = document.querySelectorAll(
    '.blog-category-filters .swipey'
  )

  if (!blogFilterSwipers) return
  if (blogFilterSwipers.length === 0) return

  blogFilterSwipers.forEach((swiperEl) => {
    // eslint-disable-next-line no-unused-vars
    const swiper = new Swiper(swiperEl, {
      // Optional parameters
      slidesPerView: 'auto',
      spaceBetween: 24,
      freeMode: {
        enabled: true,
        sticky: false,
        momentumRatio: 0.25,
        momentumVelocityRatio: 0.25,
      },
      grabCursor: true,
      centeredSlides: false,
      watchOverflow: true,
      resistanceRatio: 0.85,

      // Responsive breakpoints
      breakpoints: {
        // when window width is >= 750px
        750: {
          spaceBetween: 63,
        },
        // when window width is < 750px
        0: {
          spaceBetween: 24,
        },
      },

      // No pagination or navigation needed for filters
      // Just free scrolling
    })
  })
}

export default blogCategoryFilters
